module.exports = __webpack_public_path__ + "media/logos/logo@3x-a300398b.svg";